import React from 'react';
import { Provider } from '../context';
export const IntercomProvider = _ref => {
  let {
    children
  } = _ref;
  const [email, setEmail] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [intercom, setIntercom] = React.useState(null);
  React.useEffect(() => {
    const intercomProxy = {
      setUser: (email, userId) => {
        setEmail(email);
        setUserId(userId);
      },
      clearUser: () => {
        // @ts-ignore
        window.Intercom('shutdown');
      },
      showMessages: () => {
        // @ts-ignore
        window.Intercom('boot', {
          app_id: 'abafcwsh',
          email,
          userId
        }); // @ts-ignore

        window.Intercom('showMessages');
      },
      showHelpCenter: () => {
        // @ts-ignore
        window.Intercom('boot', {
          app_id: 'abafcwsh',
          email,
          userId
        }); // @ts-ignore

        window.Intercom('show');
      },
      hideIntercom: () => {
        // @ts-ignore
        window.Intercom('hide');
      }
    }; // @ts-ignore

    setIntercom(intercomProxy);
  }, [email, userId]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: intercom
  }, children);
};
//# sourceMappingURL=index.web.js.map